function clearNodeChildren(node) {
  if (!node) return;

  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
}

module.exports = clearNodeChildren;